export default "__VITE_ASSET__D7V39XId__"